
import React, { useRef } from 'react';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileDownloadIcon from '@mui/icons-material/GetApp';
import UbigeoTable from '../components/UbigeoTable';

export default function UbigeoManager() {
  return (
    <Box sx={{ width: '100%', mt: 1, mb: 4 }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mx: 'auto' }}>
        <UbigeoTable />
      </Box>
    </Box>
  );
}
